// extracted by mini-css-extract-plugin
export var locationCard = "_i5-0";